import { useEffect, useState } from 'react';
import { getFactoryDetail } from '../../../services/factories';

/** Плоский список камер объекта из вложенного дерева GET /factories/{id}. */
export const flattenFactoryCameras = (factory) =>
  (factory?.workshops || []).flatMap((workshop) =>
    (workshop.sections || []).flatMap((section) =>
      (section.rooms || []).flatMap((room) =>
        (room.cameras || []).map((camera) => ({ id: camera.id, name: camera.name || '' })))));

/**
 * Камеры выбранного объекта для фильтра Operational Issues (ТЗ №2 §7).
 * Один запрос детали объекта вместо каскада; при пустом factoryId — [].
 * Ошибка → [] (фильтр по камере просто недоступен, список issues не страдает).
 */
export const useFactoryCameras = (factoryId) => {
  const [cameras, setCameras] = useState([]);

  useEffect(() => {
    if (!factoryId) {
      setCameras([]);
      return undefined;
    }
    let cancelled = false;
    getFactoryDetail(factoryId)
      .then((factory) => { if (!cancelled) setCameras(flattenFactoryCameras(factory)); })
      .catch(() => { if (!cancelled) setCameras([]); });
    return () => { cancelled = true; };
  }, [factoryId]);

  return cameras;
};

export default useFactoryCameras;
